import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { VisitTypeResource } from "@app/models/rest/visit-type-resource";

@Injectable({
  providedIn: "root"
})
export class VisitTypeResourceRestService extends HateoasResourceOperation<VisitTypeResource> {
  constructor() {
    super(VisitTypeResource);
  }
}
